import React from 'react'
import ReactDOM from "react-dom";
import closeImg from "../images/close.png";
import moment from 'moment';
import { addTrailingZeros } from '../component/helpers/common';

const RecentSalesModal = (props) => {
    const { modal, setModal, data } = props;
    return ReactDOM.createPortal(
        <React.Fragment>
            <div
                className={"modal fade " + (modal ? "show " : "")}
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={modal ? { display: "block" } : { display: "none" }}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-darkgrey p-2 px-3">
                            <h1
                                className="modal-title fs-16 text-white"
                                id="exampleModalLabel"
                            >
                                Most Recent Sales
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style={{
                                    backgroundImage: `url(${closeImg})`,
                                    opacity: 1,
                                    padding: "16px",
                                }}
                                onClick={() => setModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <div className="card-table table-responsive">
                                    <table className="table table-form">
                                        <thead>
                                            <tr>
                                                <td scope="col" className="width-lg-2">Invoice Date</td>
                                                <td scope="col" className="width-lg-3">Agent</td>
                                                <td scope="col" className="width-lg-20">Product Name</td>
                                                <td scope="col" className="width-lg-1">Buy Price</td>
                                                <td scope="col" className="width-lg-1">Sell Price</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data?.map((item, index) => {
                                                return (<tr key={index + 1} className="custom-space remove-left-space">
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm text-end input-width-80"
                                                            defaultValue={moment(item?.InvoiceDate).format('MM/DD/YYYY')}
                                                            disabled
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm input-width-50"
                                                            defaultValue={item?.tblOrderDetails[0]?.tblAgent?.AgentCode}
                                                            disabled
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm input-width-80"
                                                            defaultValue={`${item?.tblOrderDetails[0]?.Qty} * ${item?.tblOrderDetails[0]?.tblUnit?.UnitName}  ${item?.tblOrderDetails[0]?.ProductName}`}
                                                            disabled
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="position-relative input-icon">
                                                            <input
                                                                type="text"
                                                                className="form-control input-sm text-end input-width-70"
                                                                defaultValue={addTrailingZeros(item?.tblOrderDetails[0]?.BuyPrice)}
                                                                disabled
                                                            />
                                                            <span className="text-lite cps-10 fs-14">$</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="position-relative input-icon">
                                                            <input
                                                                type="text"
                                                                className="form-control input-sm text-end input-width-70"
                                                                defaultValue={addTrailingZeros(item?.tblOrderDetails[0]?.SellPrice)}
                                                                disabled
                                                            />
                                                            <span className="text-lite cps-10 fs-14">$</span>
                                                        </div>
                                                    </td>
                                                </tr>)
                                            })}

                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">

                            <div className="col d-flex justify-content-end align-items-end">

                                <button
                                    onClick={() => setModal(false)}
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    Exit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal ? <div className="modal-backdrop fade show" /> : ""}
        </React.Fragment>,
        document.getElementById("modal-root")
    );
}

export default RecentSalesModal
